<template>
  <div id="covid-module-fullscreen">
    <div id="covid-page-header">
      <app-icon
        name="coronavirus"
        size="normal"/>
      <span>COVID-19 &#8226; {{ contents.CovidModule.infos[1].nom }}</span>
    </div>
    <div id="covid-data">
      <div class="data">
        <div class="value">{{ contents.CovidModule.infos[1].nouvellesHospitalisations }}</div>
        <span class="title">Nouvelles hospitalisations pour Covid-19 dans le département sur 24h</span>
      </div>
      <div class="data">
        <div class="value">{{ contents.CovidModule.infos[1].nouvellesReanimations }}</div>
        <span class="title">Admissions en réanimation pour Covid-19 dans le département sur 24h</span>
      </div>
      <div class="data">
        <div class="value" :class="contents.CovidModule.status.h">
          {{ contents.CovidModule.infos[1].hospitalises }}
          <app-icon
            :name="contents.CovidModule.status.h"
            size="micro"/>
        </div>
        <span class="title">Hospitalisations en cours</span>
        <span id="details">
          {{ Math.abs(contents.CovidModule.infos[1].hospitalises - contents.CovidModule.infos[0].hospitalises) }} patient(s) de
          {{ contents.CovidModule.infos[1].hospitalises - contents.CovidModule.infos[0].hospitalises >= 0 ? 'plus' : 'moins' }}
          que la journée d'hier.
        </span>
      </div>
      <div class="data">
        <div class="value" :class="contents.CovidModule.status.r">
          {{ contents.CovidModule.infos[1].reanimation }}
          <app-icon
            :name="contents.CovidModule.status.r"
            size="micro"/>
        </div>
        <span class="title">Réanimations en cours</span>
        <span id="details">
          {{ Math.abs(contents.CovidModule.infos[1].reanimation - contents.CovidModule.infos[0].reanimation) }} patient(s) de
          {{ contents.CovidModule.infos[1].reanimation - contents.CovidModule.infos[0].reanimation >= 0 ? 'plus' : 'moins' }}
          que la journée d'hier.
        </span>
      </div>
    </div>
    <div id="covid-instructions">
      <div class="instruction">
        <app-icon
          name="mask"
          size="normal"/>
        <div class="list">
          <span>
            &#8226; Porter un masque quand la distanciation physique ne peut pas être respectée,
            et dans tous les lieux où cela est obligatoire.
          </span>
          <span>&#8226; Couvrir le nez et la bouche</span>
        </div>
      </div>
      <div class="instruction">
        <app-icon
          name="reduce_capacity"
          size="normal"/>
        <div class="list">
          <span>
            &#8226; Respecter une distance d'au moins un mètre avec les autres.
          </span>
          <span>&#8226; Saluer sans serrer la main et arrêter les embrassades.</span>
          <span>&#8226; Limiter autant que possible les regroupements.</span>
        </div>
      </div>
      <div class="instruction">
        <app-icon
          name="wash"
          size="normal"/>
        <div class="list">
          <span>
            &#8226; Se laver régulièrement les mains ou utiliser une solution hydro-alcoolique.
          </span>
          <span>
            &#8226; Se laver les mains à l'eau et au savon pendant 30 secondes est la mesure
            d'hygiène la plus efficace pour prévenir la transmission de tous les virus.
          </span>
        </div>
      </div>
      <div class="instruction">
        <app-icon
          name="privacy"
          size="normal"/>
        <div class="list">
          <span>
            &#8226; Éviter de partager les objets de tous les jours.
          </span>
          <span>
            &#8226; Ne pas se toucher la bouche, le nez, les yeux.
          </span>
        </div>
      </div>
    </div>
    <div id="qr-code">
      <vue-qrcode
        value="https://www.gouvernement.fr/info-coronavirus"
        :options="{ width: 150 }" />
      <span>
        Retrouvez plus d'informations sur le site dédié du gouvernement en flashant le QR-code avec votre smartphone
      </span>
    </div>
    <div class="dock">
      <div class="dock-banner">
        <div class="dock-item" @click='resetTimer()'>
          <Waiter
            :relativeProgress='timerRelativeProgress'
            icon="replay"
            color="rgba(255,255,255, 1)" />
        </div>
        <div class="dock-button">
          <app-icon
            @click="stopConsultation()"
            name="dockHomeButton"
            size="inter"
            color="black"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass">
#covid-module-fullscreen
  background: conic-gradient(at -10% 40%, rgba(255, 255, 255, .85) 10%, rgba(255, 255, 255, .95) 32%, rgba(255, 255, 255, 1) 36%)
  bottom: 0
  height: 100vh
  left: 0
  position: fixed
  top: 0
  right: 0
  width: 100vw
#covid-page-header
  align-items: center
  display: flex
  height: 10rem
  justify-content: center
  svg
    color: #009A02
#covid-data
  align-items: center
  display: flex
  flex-wrap: wrap
  justify-content: space-between
  margin-bottom: 2rem
  margin-top: 3rem
  padding: 0 1rem
  .data
    background: rgba(255, 255, 255, .8)
    border-radius: 3px
    box-shadow: 0 0 5px 2px rgba(0,0,0,.1)
    height: 13rem
    margin: .5rem 0
    padding: .8rem
    position: relative
    width: 30.5rem
    #details
      font-family: 'RobotoRegular'
      font-size: .45em
      margin-top: .6rem
    .value
      align-items: center
      color: #424242
      display: flex
      font-family: 'RobotoMedium'
      font-size: 2.2em
      &.south
        svg
          color: #1b5e20
      &.north
        svg
          color: #b71c1c
      &.unfold_less
        svg
          color: #263238
    .title
      color: #1b1b1b
      font-family: 'RobotoRegular'
      font-size: .65em
      margin-top: .8rem
#covid-instructions
  margin: 6rem 0
  padding: 0 1rem
.instruction
  align-items: center
  // border-radius: 3px
  // box-shadow: 0 0 5px 2px rgba(0,0,0,.1)
  display: flex
  height: 8rem
  margin: 2.8rem 0
  padding: .7rem 6.5rem
  position: relative
  svg
    color: #484848
    margin-right: 1rem
  .list
    display: flex
    flex-direction: column
    height: 100%
    justify-content: center
    left: 17rem
    position: absolute
    right: 5rem
    span
      font-family: 'RobotoRegular'
      font-size: .6em
      margin: .5rem 0 .4rem 0
#qr-code
  align-items: center
  bottom: 0
  display: flex
  height: 13.5rem
  left: 0
  padding: 0 1rem
  position: absolute
  right: 0
  span
    font-size: .6em
    margin-left: .5rem
    text-align: justify
    width: 35rem
</style>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';
import AppIcon from '@/components/icons/AppIcon.vue';
import Waiter from '@/components/appModules/Waiter.vue';

export default {
  name: 'FullscreenCovidModule',

  components: {
    AppIcon,
    VueQrcode,
    Waiter,
  },

  props: {
    contents: Object,
  },

  data() {
    return {
      TIMER_DURATION: 35000,
      timerStartTime: null,
      timerRelativeProgress: 0,
      timerAnimation: null,
    };
  },

  methods: {
    stopConsultation() {
      this.$router.push({ name: 'home' });
    },

    animateTimer(timestamp) {
      if (!this.timerStartTime) this.timerStartTime = timestamp;

      const runTime = timestamp - this.timerStartTime;
      this.timerRelativeProgress = runTime / this.TIMER_DURATION;

      if (runTime < this.TIMER_DURATION) {
        this.timerAnimation = requestAnimationFrame(this.animateTimer);
      } else {
        cancelAnimationFrame(this.timerAnimation);
        this.timerAnimation = null;
        this.timerStartTime = null;
        this.timerRelativeProgress = 0;
        this.stopConsultation();
      }
    },

    resetTimer() {
      cancelAnimationFrame(this.timerAnimation);
      this.timerAnimation = null;
      this.timerStartTime = null;
      this.timerRelativeProgress = 0;
      this.timerAnimation = requestAnimationFrame(this.animateTimer);
    },
  },

  activated() {
    this.timerAnimation = requestAnimationFrame(this.animateTimer);
  },

  deactivated() {
    cancelAnimationFrame(this.timerAnimation);
    this.timerAnimation = null;
    this.timerStartTime = null;
    this.timerRelativeProgress = 0;
  },

  filters: {
    formatDate(value) {
      const d = new Date(value);
      const options = { day: 'numeric', year: 'numeric', month: 'numeric' };
      return new Intl.DateTimeFormat('fr-FR', options).format(d);
    },
  },
};
</script>
